let lenisInstance = null;

export const setLenis = (instance) => {
    lenisInstance = instance;
};

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const scrollToTop = () => {
    if (lenisInstance) {
        lenisInstance.scrollTo(0, { immediate: true });
    }
    window.scrollTo(0, 0);
};
